// extracted by mini-css-extract-plugin
module.exports = {"container":"Professional_container__2FgW1","title":"Professional_title__XHVJm","content":"Professional_content__1fzXf","img":"Professional_img__3FutD"};